import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export const ComingSoonBadge = () => {
  const { t } = useLocoTranslation()

  return (
    <div
      className={
        'border-1 border-brand-primary text-brand-primary bg-brand-primary/10 w-fit rounded-md px-2.5 py-1.5'
      }
    >
      {t('global.coming_soon')}
    </div>
  )
}
